import { graphql, useStaticQuery } from "gatsby"

type SiteMetadata = {
    title: string
    description: string
    image: string
    siteUrl: string
    twitterUsername: string
}

export const useSiteMetadata: () => SiteMetadata = () => {
    const data = useStaticQuery<{
        site: { siteMetadata: SiteMetadata }
    }>(graphql`
        query SEO {
            site {
                siteMetadata {
                    title
                    description
                    twitterUsername
                    image
                    siteUrl
                }
            }
        }
    `)

    return data.site.siteMetadata
}
